import { action } from "mobx";
import { BaseEditViewStore } from "core/stores";
import { NikoPatientDetailService } from "application/niko-patient/services";
import { NikoPatientEligibilityStatusNoteModalForm } from 'application/niko-patient/forms';

class NikoPatientEligibilityStatusNoteModalStore extends BaseEditViewStore {
	constructor(rootStore, componentProps) {
        const nikoPatientDetail = componentProps.modalParams.data.nikoPatientDetail;
        const nikoPatientDetailService = new NikoPatientDetailService(rootStore.application.baasic.apiClient);
        super(rootStore, {
			name: 'niko-patient-eligibility-status-note-modal',
			Form: NikoPatientEligibilityStatusNoteModalForm,
			id: nikoPatientDetail.id,
			actions: () => {
				return {
					get: async () => {
						return nikoPatientDetail;
					},
					update: async () => {
						await nikoPatientDetailService.updatePatientInsuranceInfo(this.nikoPatientDetail);
					}
				}
			},
			FormClass: NikoPatientEligibilityStatusNoteModalForm
		});

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.nikoPatientDetail = nikoPatientDetail;
    }

	@action.bound
	async updateResource(resource) {
		if (!this.actions.update) return;

		this.form.setFieldsDisabled(true);
		try {
			if (this.translationStore) {
				this.translationStore.applyMetadata(resource);
			}

			this.nikoPatientDetail.eligibilityStatusNote = this.form.$("eligibilityStatusNote").value;
			await this.actions.update();
			this.modalParams.close();
		}
		catch (err) {
			this.form.setFieldsDisabled(false);
			return this.onUpdateError(err);
		}
	}
}

export default NikoPatientEligibilityStatusNoteModalStore;